import React from "react";
import { Container } from "shards-react";

const Unauthorized = () => (
  <Container fluid className="main-content-container px-4 pb-4">
    <div className="error">
      <div className="error__content">
        <h2>401</h2>
        <h3>NO AUTORIZADO!</h3>
      </div>
    </div>
  </Container>
);

export default Unauthorized;
